import React, { useState, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'

import { buyCoaching } from '../../redux/actions/marketplace'

import CheckboxComponent from '../../components/CommonComponents/CheckboxComponent'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'

import { formatValue } from '../../services/helper'

const topicList = [
  { value: 'software', name: 'Software' },
  { value: 'waste', name: 'Optimization/Reducing Wasted Ad Spend' },
  { value: 'scaling', name: 'Expansion/Scaling' },
  { value: 'seo', name: 'SEO/Listing Optimization' },
  { value: 'creative', name: 'Creative Elements (headlines/video/images)' },
  { value: 'strategy', name: 'Strategy' },
  { value: 'profitability', name: 'Margins/Profitability' },
]

const totalPrice = 297

const CoachingInfo = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth0()

  const balance = useSelector(state => state.coin.balance)

  const [selectedTopics, setSelectedTopics] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleToggleTopic = (topic, checked) => {
    const newTopics = [...selectedTopics]
    if (checked) {
      newTopics.push(topic)
    } else {
      newTopics.splice(newTopics.indexOf(topic), 1)
    }
    setSelectedTopics(newTopics)
  }

  const handleSubmit = async () => {
    const topics = []
    topicList.forEach((topic) => {
      if (selectedTopics.indexOf(topic.value) !== -1) {
        topics.push(topic.name)
      }
    })

    setIsSubmitting(true)
    const accessToken = await getAccessTokenSilently()
    dispatch(buyCoaching(accessToken, topics)).then(() => {
      setIsSubmitting(false)
      toast.show({
        title: 'Success',
        description: 'Purchased successfully.',
      })

      window.open('https://go.oncehub.com/CoachingEntourage', '_blank')
    }).catch((error) => {
      setIsSubmitting(false)
      toast.show({
        title: 'Danger',
        description: error,
      })
    })
  }

  const renderTopics = () => {
    return topicList.map(topic => (
      <div key={topic.value} className="topic-item">
        <CheckboxComponent
          label={topic.name}
          checked={selectedTopics.indexOf(topic.value) !== -1}
          onChange={(checked) => { handleToggleTopic(topic.value, checked) }}
        />
      </div>
    ))
  }

  return (
    <div className={`coaching-info${isSubmitting ? ' loading' : ''}`} ref={ref}>
      { isSubmitting && <LoaderComponent /> }
      <div className="product-name">
        Entourage Coaching: <span>297 Coins/USD</span>
      </div>
      <div className="product-description">
        Please select one or more topics that you would like to discuss on the coaching call.
      </div>
      <div className="topic-list">
        { renderTopics() }
      </div>
      <div className="purchase-section">
        <div className="price-wrapper">
          <span className="coin-balance">
            <span className="coin-label">
            </span>
            { formatValue(balance, 'number', 0) }
          </span>
          <span className="additional-cost">
            + { formatValue(totalPrice - balance, 'currency', 2, '$') }
          </span>
          <span className="conversion-wrapper">
            <span className="conversion-label">
              Conversion:
            </span>
            <span className="conversion-value">
              <span className="coin-label">
              </span>
              1 = 1 USD
            </span>
          </span>
        </div>
        <button
          type="button"
          className="btn btn-red"
          disabled={isSubmitting}
          onClick={handleSubmit}
        >
          Buy Coaching
        </button>
      </div>
    </div>
  )
})

export default CoachingInfo
